import React from 'react';
import GroupOrdersImplementation from './GroupOrdersImplementation';

const GroupOrdersManager = ({ restaurants }) => {
  return <GroupOrdersImplementation restaurants={restaurants} />;
};

export default GroupOrdersManager;